import Vue from 'vue';
import { mapState } from 'vuex'
import Store from './components/Giftcard/store.js'
import Wizard from './components/Giftcard/Wizard.vue'
import Preview from './components/Giftcard/Preview.vue'
import { Lang } from "laravel-vue-lang";
import store from './components/Giftcard/store.js';

Vue.use(Lang, {
    fallback: "en"
});

window.giftcardApp = new Vue({
    el: "#giftcard-holder",
    store: Store,
    components: {
        'giftcard-wizard': Wizard,
        'giftcard-preview': Preview
    },
    data() {
        return {
            coupon: false
        }
    },
    computed: mapState([
        'plan',
        'step',
        'sender_name',
        'stipe_key',
        'stipe_secret',
    ]),
    methods: {
        setCoupon: function (val) {
            console.log('coupon has new val ' + val);
            this.coupon = val;
        }
    },
    beforeMount() {
        store.commit('setStripeKey', this.$el.dataset.stripe_key);
        store.commit('setSuccessUrl', this.$el.dataset.success);
        store.commit('setPlan', JSON.parse(this.$el.dataset.plan));
    },
});
